import React from 'react'
import { useTranslations } from 'next-intl'

import { CLEARTRIP } from '@/src/constants/buildVariants'
import { HOLIDAYS_POWERED_BY_LOGO } from '@/src/constants/holidays'
import { VARIANT } from '@/src/utils/buildUtils'

import PoweredBy, { type PoweredByProps } from './poweredBy'

type PoweredByWrapperProps = Pick<PoweredByProps, 'height' | 'align'>

/** Cleartrip's holiday packages are fulfilled by Musafir; Flyin shows nothing. */
const PoweredByWrapper: React.FC<PoweredByWrapperProps> = ({ height, align }) => {
    const t = useTranslations('holidaysPage')
    if (VARIANT !== CLEARTRIP) return null

    return <PoweredBy src={HOLIDAYS_POWERED_BY_LOGO} alt={t('poweredByMusafir')} height={height} align={align} />
}

export { PoweredByWrapper }
export default PoweredByWrapper
